<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('EditDailyCashierReport') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="dailyCashierReport.date"></datepicker>

                <div class="vx-row mt-3" :data="item" :key="item.id" v-for="(item, index) in dailyCashierReport.items">
                    <vs-divider/>

                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <small>{{$t('User') |ToUppercase}}</small><br>
                        <vs-select v-model="item.userID" class="selectExample w-full mb-63">
                            <vs-select-item v-for="(item,index) in users" :key="index" :text='item.firstname + " " + item.lastname' :value="item.id"/>
                        </vs-select>
                    </div>

                    <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
                        <small>{{$t('Shift') |ToUppercase}}</small><br>
                        <vs-select v-model="item.shiftID" class="selectExample w-full mb-3">
                            <vs-select-item v-for="(item,index) in shifts" :key="index" :text="item.name" :value="item.id"/>
                        </vs-select>
                    </div>
                    
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Cash') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="item.cash" @input="updateTotalCash(item)"/>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Pos') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="item.pos" @input="updateTotalPos(item)"/>
                    </div>
                    <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
                        <small>{{$t('Total') |ToUppercase}} (€)</small><br>
                        <vs-input class="w-full" type="number" name="name" v-model="item.total"/>
                    </div>

                    <div class="vx-col sm:w-1/1 md:w-1/1 w-full">
                        <small>{{$t('Notes') |ToUppercase}}</small><br>
                        <vs-input class="w-full" type="text" name="notes" v-model="item.notes"/>
                    </div>
                </div>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="addItem">{{ $t("AddItem") | ToUppercase }}</vs-button>
                    <vs-button class="mr-2" @click="editDailyCashierReport">{{ $t("Edit") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                    
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                dailyCashierReport: {},
                reportDate: null,
                selectedUser: '',
                selectedShift: '',
                users: [],
                shifts: [],
            };
        },
        methods: {
            updateTotalCash(item) {
                if((item.cash.match(/^\d+[\.\,]?\d{0,2}$/)) != null) {
                    item.cash = parseFloat((item.cash.match(/^\d+[\.\,]?\d{0,2}$/)).input);
                    item.cash_previous = item.cash;
                }
                else {
                    if(item.cash.toString().length > 1) {
                        item.cash = item.cash_previous;
                    }
                }

                item.total = Math.round((parseFloat(item.cash) + parseFloat(item.pos)) * 100) / 100;
            },
            updateTotalPos(item) {
                if((item.pos.match(/^\d+[\.\,]?\d{0,2}$/)) != null) {
                    item.pos = parseFloat((item.pos.match(/^\d+[\.\,]?\d{0,2}$/)).input);
                    item.pos_previous = item.pos;
                }
                else {
                    if(item.pos.toString().length > 1) {
                        item.pos = item.pos_previous;
                    }
                }

                item.total = Math.round((parseFloat(item.cash) + parseFloat(item.pos)) * 100) / 100;
            },
            addItem() {
                var tempDailyReport = {
                    cash: 0,
                    pos: 0,
                    total: 0,
                    shiftID: 0,
                    userID: 0,
                    notes: ''
                }
                this.dailyCashierReport.items.push(tempDailyReport);
            },
            updateUsers() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/users/')
                .then(function (response) {
                    thisIns.users = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju uporabnikov",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateShifts() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/shift/')
                .then(function (response) {
                    thisIns.shifts = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju izmen",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            updateDailyCashierReport() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/report/' + this.$route.params.report_id + '?type=dailyCashier')
                .then(function (response) {
                    thisIns.dailyCashierReport = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            editDailyCashierReport() {
                this.$vs.loading();
                
                for (var i = 0; i < this.dailyCashierReport.items.length; i++) {
                    this.dailyCashierReport.items[i].cash = parseFloat(this.dailyCashierReport.items[i].cash);
                    this.dailyCashierReport.items[i].pos = parseFloat(this.dailyCashierReport.items[i].pos);
                    this.dailyCashierReport.items[i].total = parseFloat(this.dailyCashierReport.items[i].total);
                }

                const thisIns = this;
                this.$http.put('/report/' + this.$route.params.report_id + '?type=dailyCashier', {
                    id: thisIns.dailyCashierReport.id,
                    date: thisIns.dailyCashierReport.date,
                    items: thisIns.dailyCashierReport.items
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Dnevno poročilo blagajne shranjeno",
                        color: "success",
                    });
                    thisIns.$router.push('/report/dailyCashier');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            this.updateShifts();
            this.updateUsers();
            this.updateDailyCashierReport();
        },
    };
</script>